import { render, staticRenderFns } from "./merchant_page.vue?vue&type=template&id=085ed417&scoped=true"
import script from "./merchant_page.vue?vue&type=script&lang=js"
export * from "./merchant_page.vue?vue&type=script&lang=js"
import style0 from "./merchant_page.vue?vue&type=style&index=0&id=085ed417&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ed417",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085ed417')) {
      api.createRecord('085ed417', component.options)
    } else {
      api.reload('085ed417', component.options)
    }
    module.hot.accept("./merchant_page.vue?vue&type=template&id=085ed417&scoped=true", function () {
      api.rerender('085ed417', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/merchant/merchant_page.vue"
export default component.exports